import { getFullName } from "shared/utils/get-full-name";
import { Applicant } from "types/application";

/**
 * Parses AI-generated content and replaces tags with actual data.
 * Currently supports:
 * - @applicant[24] - Replaced with applicant's full name
 *
 * @param content - The AI-generated content containing tags
 * @param applicants - Array of applicants from the application
 * @returns Parsed content with tags replaced by actual values
 */
export const parseAIContent = (
  content: string,
  applicants: Applicant[]
): string => {
  // Regular expression to match applicant tags with any id
  // Matches @applicant[24]
  const applicantTagRegex = /@applicant\[(\d+)\]/gi;

  return content.replace(applicantTagRegex, (_, idString) => {
    const id = parseInt(idString, 10);
    const applicant = applicants.find((app) => app.id === id);

    if (!applicant) return `[Applicant #${id}]`;

    return getFullName({
      firstName: applicant.first_name,
      lastName: applicant.last_name,
      middleName: applicant.middle_name,
      short: true
    });
  });
};
